import { ActivityVerbEnum } from "@shared/model/enum/activity-verb-enum";
import { Strategy } from "../model/notification.model";
import { ActivityTextStrategy } from "../strategies/activity-text-strategy";
import { CommentTextStrategy } from "../strategies/comment-text-strategy";
import { LikeTextStrategy } from "../strategies/like-text-strategy";

export const NotificationStrategyMap: Partial<Record<ActivityVerbEnum, Strategy>> = {

    // ?This map connects each activity type (verb) to its matching strategy class.
    //? The factory uses it to find which strategy should create the notification text.


    // Comment
    [ActivityVerbEnum.Commented]: CommentTextStrategy,

    // Like
    [ActivityVerbEnum.Liked]: LikeTextStrategy,
    [ActivityVerbEnum.Reacted]: LikeTextStrategy,

    // General
    [ActivityVerbEnum.Reviewed]: ActivityTextStrategy,
    [ActivityVerbEnum.Rated]: ActivityTextStrategy,
    [ActivityVerbEnum.Quoted]: ActivityTextStrategy,
    [ActivityVerbEnum.Posted]: ActivityTextStrategy,
    [ActivityVerbEnum.Booklisted]: ActivityTextStrategy,
    [ActivityVerbEnum.UserReportPublished]: ActivityTextStrategy,
    [ActivityVerbEnum.StateChangedToRead]: ActivityTextStrategy,
    [ActivityVerbEnum.StateChangedToCurrently]: ActivityTextStrategy,
    [ActivityVerbEnum.StateChangedIWantToRead]: ActivityTextStrategy,
    [ActivityVerbEnum.ReadingProgressed]: ActivityTextStrategy,
    [ActivityVerbEnum.ChallengeObtained]: ActivityTextStrategy,
    [ActivityVerbEnum.AchievementObtained]: ActivityTextStrategy,
    [ActivityVerbEnum.ChallengePicked]: ActivityTextStrategy,
    [ActivityVerbEnum.Clubed]: ActivityTextStrategy,
};
